import type { FaireProductEntity } from "../../entity_types/product";

export const p_safcg3yevd: FaireProductEntity = {
  token: "p_safcg3yevd",
  type: "product",
  name: "Glitter HOGS Earrings",
  brandToken: "b_hfw2t2ygt4",
  brandName: "Southern Designs by Kristy",
  imageUrl:
    "https://cdn.faire.com/fastly/bbb292f909f635e6acc061e30fd651f2272007f883c67ca4df83aa575cad9d82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bccc52bfe36a7cf921a94679b7a120b0763953d1e51c43aa590f563716d8a2dc.jpeg",
    "https://cdn.faire.com/fastly/b5a86bdc7dfdd4b451fbea9445d7ee0dd8e7b85193c58e788d37f1216d7e6eb1.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Show off your Razorback pride with a touch of sparkle! Our Glitter HOGS Earrings are the ultimate statement piece for game day, tailgates, and cheering on the Hogs in style.\n\n✨ Details:\n\n * Bold red glitter acrylic with lightweight comfort \n * Black and gold stud topper for a luxe finish \n * Approx. 2.5” drop length \n * Nickel-free & hypoallergenic posts \nPerfect for pairing with your favorite Razorback tee or a chic game day outfit, these earrings are designed to shine under the stadium lights (and everywhere else you go). Whether you’re in the stands, at a tailgate, or watching from home, these earrings make sure your team spirit stands out loud and proud!\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:22.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
